/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { IMenuItem } from '../interfaces/menuItem';
import { Router } from '@angular/router';
import { IMenuProvider } from '../interfaces/menuProvider';

/**
 * TDefault class for empty menu entires
 * @class MenuItem
 */
export class EmptyMenuItem implements IMenuItem{

    constructor(public id:number, public parent:IMenuItem = null){ }
    public provider:IMenuProvider = null;
    public isDisabled:boolean = false;
    public isSelected:boolean = false;
    public text:string = "";
    public action:string = "";
    public childs: Array<IMenuItem> = [];
    public async selectAction():Promise<boolean>{  return false; }

}